angular.module('manageSysManageSMSTempConfigModule', [])
	.controller('manageSysManageSMSTempConfigCtrl', ['$scope', function($scope){
		console.log("这里是短信模板设置")
	}]);